import React, {useRef} from 'react';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import OilThumb from '../../OilThumb';
import OilBaseInfomation from '../../OilBaseInfomation';
import OilVolumesService from '../../OilVolumesService';
import Printable from '../../../RecommendationPrintable/Product';
import {useReactToPrint} from 'react-to-print';
import {
  IComponentVolumes,
  IModal,
  IProd,
  IServiceIntervals,
  IState,
  ProductCategory,
  Replacement,
} from '../../../../interface';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import actions from '../../../../redux/actions';
import _ from 'lodash';
import {useSearchParams} from 'react-router-dom';
import {useAppName} from '../../../../hooks/use-app-names';
import {APPNAME, FASTSCAN} from '../../../../constants';
import localesReplacement from '../../../../utils/localesReplacement';

const cx = classnames.bind(style);

interface IProps {
  replacements: Replacement;
  dataList: IProd;
  productCategories: ProductCategory[];
  vehicleComponentVolumes: IComponentVolumes[];
  setVehicleComponentVolumes: (value: IComponentVolumes[]) => void;
  setServiceIntervals: (value: IServiceIntervals[]) => void;
  componentName: string | undefined;
  vehicle?: any;
  notes?: string[];
  onlyThumb?: boolean;
}

export const AlternativeRecommendation = (props: IProps) => {
  const {
    replacements,
    dataList,
    productCategories,
    vehicleComponentVolumes,
    setServiceIntervals,
    setVehicleComponentVolumes,
    componentName,
    vehicle,
    notes,
    onlyThumb,
  } = props;
  const isFastScan = useAppName(FASTSCAN);
  const ref = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const moreLinkClick = () => {
    setServiceIntervals(dataList.serviceIntervals ?? []);
    setVehicleComponentVolumes(vehicleComponentVolumes);
    searchParams.set('id', _.toString(dataList.id));
    searchParams.set('page', 'product');
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
  };

  const printOptions = {
    content: () => ref?.current,
    copyStyles: true,
  };
  const handlePrint = useReactToPrint(printOptions);

  return (
    <>
      <Printable
        title='Alternative Recommendation'
        ref={ref}
        vehicle={vehicle}
        componentName={componentName || ''}
        volumes={vehicleComponentVolumes}
        notes={notes}
        data={dataList}
      />
      <div className={cx('section')}>
        <h4 className={cx('section-title')}>{dataList['name']}</h4>
        <div className={cx('inner')}>
          <div className={cx('sider')}>
            <OilThumb
              withoutMoreLink={true}
              dataList={dataList}
              moreLinkClick={moreLinkClick}
              onPrintClick={handlePrint}
              vehicleP={vehicle}
              products={dataList}
              componentName={componentName}
              Recommendation='alternative recommendation'
              onlyThumb={true}
              maxSize={104}
            />
          </div>
          <div className={cx('content')}>
            <OilBaseInfomation
              withoutMoreLink={false}
              dataList={dataList}
              productCategories={productCategories}
              moreLinkClick={moreLinkClick}
              onPrintClick={handlePrint}
              vehicle={vehicle}
              products={dataList}
              componentName={componentName}
              onlyThumb={onlyThumb}
            />
            {!onlyThumb && (
              <OilVolumesService
                notes={notes}
                withoutMoreLink={true}
                dataList={dataList}
                moreLinkClick={moreLinkClick}
              />
            )}
            <div className={style['links']}>
              <span
                onClick={moreLinkClick}
                className='secondary-button'
                role='button'
              >
                {localesReplacement(replacements, 'View product details')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  modal: state.modal,
  replacements: state.replacements,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setModal: (value: IModal) => dispatch(actions.setModal(value)),
  setServiceIntervals: (value: IServiceIntervals[]) =>
    dispatch(actions.setServiceIntervals(value)),
  setVehicleComponentVolumes: (value: IComponentVolumes[]) =>
    dispatch(actions.setVehicleComponentVolumes(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlternativeRecommendation);
